<template>
    <el-form :inline="true" class="demo-form-inline">
          <el-form-item label="关键字：">
              <el-input v-model="formInline.name" placeholder="请输入模板名称"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="search()">搜索</el-button>
            <el-button type="primary" @click="showAdd()">新建</el-button>
          </el-form-item>
      </el-form>
      <el-table class="table_wrapper" :data="tableData" :header-cell-style="{'text-align':'left'}" :cell-style="{'text-align':'left'}">
        <el-table-column label="模板名称" show-overflow-tooltip>
          <template #default="scope">
            <div>
              <span>{{ scope.row.name }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="尖段电费成本">
          <template #default="scope">
            <div>
              <span>{{ scope.row.spikeCost || '--' }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="峰段电费成本">
          <template #default="scope">
            <div>
              <span>{{ scope.row.peakCost || '--' }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="平段电费成本">
          <template #default="scope">
            <div>
              <span>{{ scope.row.flatCost || '--' }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="谷段电费成本">
          <template #default="scope">
            <div>
              <span>{{ scope.row.valleyCost || '--' }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" width="200">
          <template #default="scope">
            <div>
              <span>{{ scope.row.createTime || '--' }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="更新时间" width="200">
          <template #default="scope">
            <div>
              <span>{{ scope.row.updateTime || '--' }}</span>
            </div>
          </template>
        </el-table-column>
        
        <el-table-column label="操作" width="150" fixed="right">
          <template #default="scope">
            <el-button size="small" @click="handleEdit(scope.$index, scope.row)">
              编辑
            </el-button>
            <el-button
              size="small"
              type="danger"
              @click="handleDelete(scope.$index, scope.row)"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <Pagination
          v-model:current-page="currentPage"
          v-model:page-size="pageSize"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
      />
  
      <!-- 对话框--新建、编辑组织 -->
      <el-dialog v-model="dialogFormVisible" :title="dialogTitle" width="500" :close-on-click-modal="false">
          <el-form label-position="right" label-width="auto" :model="addInfo">
          <el-form-item label="模板名称">
            <el-input v-model="addInfo.name" autocomplete="off" />
          </el-form-item>
          <el-form-item label="尖段电费成本">
            <el-input v-model="addInfo.spikeCost" autocomplete="off" />
          </el-form-item>
          <el-form-item label="峰段电费成本">
            <el-input v-model="addInfo.peakCost" autocomplete="off" />
          </el-form-item>
          <el-form-item label="平段电费成本">
            <el-input v-model="addInfo.flatCost" autocomplete="off" />
          </el-form-item>
          <el-form-item label="谷段电费成本">
            <el-input v-model="addInfo.valleyCost" autocomplete="off" />
          </el-form-item>
          </el-form>
          <template #footer>
          <div class="dialog-footer">
              <el-button @click="dialogFormVisible = false">取消</el-button>
              <el-button type="primary" @click="saveInfo()">确定</el-button>
          </div>
          </template>
      </el-dialog>
  
      <!-- 对话框--删除 -->
      <el-dialog
        v-model="centerDialogVisible"
        title="提示"
        width="500"
        align-center
      >
        <span>确定删除该模板吗？</span>
        <template #footer>
          <div class="dialog-footer">
            <el-button @click="centerDialogVisible = false">取消</el-button>
            <el-button type="primary" @click="deleteUser()">确定</el-button>
          </div>
        </template>
      </el-dialog>
  
    </template>
    
    <script>
    export default {
    name:'ElectricityCost',
    data() {
      return {
        formInline:{
          mode:'',
          name:''
        },
        typeOptions:[
          {
            label:'全部',
            value:''
          },
          {
            label:'服务费分成',
            value:1
          },
          {
            label:'电量分成',
            value:2
          },
          {
            label:'收益分成',
            value:3
          }
        ],
        selectedRoles: [],
        rolesList:[
          {
            label:'服务费分成',
            value:1
          },
          {
            label:'电量分成',
            value:2
          },
          {
            label:'收益分成',
            value:3
          }
        ],
        isUpdate:false,
        dialogTitle:'添加分成方',
        dialogFormVisible:false,
        centerDialogVisible:false,
        currt_id:'', //当前操作id
        tableData:[],
        addInfo:{
          name:'',
          type:'',
          username:'',
          account:'',
          bankOf:'',
          date:[],
          time:'',
        },
        total: 0, //总条数
        currentPage: 1, //当前页
        pageSize: 10, //每页显示条数
      }
    },
    components: {
      
    },
    computed: {
      filteredMessage() {
        // 这里可以实现类似过滤器的转换逻辑
      }
    },
    beforeCreate(){
      
    },
    created(){
      
    },
    mounted(){
      this.getList();
    },
    methods:{
      handleSizeChange (val) { //每页显示条数
          this.pageSize = val;
          this.currentPage = 1;
          this.getList();
      },
      handleCurrentChange(val) { //当前页
          this.currentPage = val;
          this.getList(); //获取列表
      },
      search(){
        //搜索
        let that = this;
        let param = {};
        param.page = 1;
        param.pageSize = this.pageSize;
        param.name = that.formInline.name;
        // console.log(that.formInline);
        if(that.formInline.date && that.formInline.date.length > 0){
          param.start = that.formInline.date[0];
          param.end = that.formInline.date[1];
        }
        that.$axios.post(that.$store.state.platformApi+"cost/template/page",JSON.stringify(param)).then(result => {
          if(result.code==200){
            that.tableData = result.data.records;
            that.total = result.data.total;
          }
        })
      },
      getList(){
        //获取列表
        let that = this;
        let param = {};
        param.page = this.currentPage;
        param.pageSize = this.pageSize;
        param.name = that.formInline.name;
        that.$axios.post(that.$store.state.platformApi+"cost/template/page",JSON.stringify(param)).then(result => {
          if(result.code==200){
            that.tableData = result.data.records;
            that.total = result.data.total;
          }
        })
      },
      saveInfo(){
        //保存
        let that = this;
        let param = {};
        if(that.isUpdate){
          //编辑
           var url = that.$store.state.platformApi+"cost/template/update";
        }else{
            var url = that.$store.state.platformApi+"cost/template/add";
        }
        param = this.addInfo;
        // console.log(this.addInfo)
        that.$axios.post(url,JSON.stringify(param)).then(result => {
          if(result.code==200){
            // 保存成功
            that.dialogFormVisible = false;
            that.getList();
          }
        });
      },
      showAdd(index,row){
        //打开添加弹窗
          this.isUpdate = false;
          this.dialogTitle = '添加模板';
          this.addInfo = Object.fromEntries(
            Object.keys(this.addInfo).map(key => [key, ''])
          );
          this.dialogFormVisible = true;
      },
      handleEdit(index,row){
        //打开编辑
        this.dialogTitle = '编辑模板';
        this.isUpdate = true;
        this.dialogFormVisible = true;
        this.addInfo = row;
      },
      deleteUser(){
        //删除
        let that = this;
        that.$axios.post(that.$store.state.platformApi+"cost/template/delete/"+that.currt_id).then(result => {
          // console.log(result);
          if(result.code==200){
            that.centerDialogVisible = false;
            that.getList();
          }
        })
      },
      handleDelete(index,row){
          //删除弹窗
        this.centerDialogVisible = true;
        this.currt_id = row.id;
      },
      typeFilter(value) {
        //过滤函数
        switch (value) {
          case 1:
            return '服务费分成';
          case 2:
            return '电量分成';
          case 3:
            return '收益分成';
          default:
            return value;
        }
      },
    }
  }
  </script>
  
  <style lang="scss" scoped>
  .search_nav{
      width: 100%;
      height: 60px;
  }
  </style>